// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { AnswerTable } from "@/features/assistant/types";

const BOM = "﻿";

function cell(value: string): string {
  // A leading = + - @ tab or CR makes spreadsheets run the cell as a formula; plain negative numbers stay numeric.
  const risky = /^[=+\-@\t\r]/.test(value) && !/^-\d+(\.\d+)?$/.test(value);
  const safe = risky ? `'${value}` : value;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

export function toCsv(table: AnswerTable): string {
  const lines = [table.columns, ...table.rows].map((row) => row.map(cell).join(","));
  return `${BOM}${lines.join("\r\n")}\r\n`;
}

export function csvFileName(table: AnswerTable, now: Date): string {
  const slug = (table.columns[0] ?? "")
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  const pad = (n: number) => String(n).padStart(2, "0");
  const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  return `${slug || "table"}-${date}.csv`;
}

export function downloadCsv(table: AnswerTable): void {
  const url = URL.createObjectURL(new Blob([toCsv(table)], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = csvFileName(table, new Date());
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
